import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../../../../Constants";

const TimeTicketForm = () => {
  const navigate = useNavigate();
  const { id, recordData } = useParams();
  const existingEntry = recordData ? JSON.parse(decodeURIComponent(recordData)) : null;

  // If existingEntry is provided, pre-fill formData with the data for editing.
  const [formData, setFormData] = useState(
     {
      employeeId: "",
      buildingSite: "",
      deviceInformation: "",
      status: "",
      problemClass: "",
      subclass: "",
      ticketNumber: "",
      type: "",
      expense: "",
      description: "",
      hoursType: "",
      hours: "",
      reg: "",
    }
  );

  // Populate form with existing data
  useEffect( () => {
    if (recordData) {
      existingEntry.filter((x)=>{
        if( x.timeTicketId == id){
          setFormData(x);
        }
      })
      
    }
  }, [id,recordData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handles both Create and Edit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const updateData = {};
        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                updateData[key] = formData[key];
            }
        });
   
    const p = JSON.stringify(updateData)
    try {
      const url = existingEntry
        ? `${API_BASE_URL}/api/admin/edit-timeTicketEntry/${id}`
        : `${API_BASE_URL}/api/admin/createTimeTicketEntry`;

      const method = existingEntry ? "PUT" : "POST"; 
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: p,
        credentials: 'include',
      });

      if (response.ok) {
        alert(
          existingEntry
            ? "Time ticket entry updated successfully"
            : "Time ticket entry created successfully"
        );
        if (!existingEntry){
          setFormData({
            employeeId: "",
            buildingSite: "",
            deviceInformation: "",
            status: "",
            problemClass: "",
            subclass: "",
            ticketNumber: "",
            type: "",
            expense: "",
            description: "",
            hoursType: "",
            hours: "",
            reg: "",
          })
        }
        navigate("/call-center/timeticket-entry-and-edit");
        
      } else {
        throw new Error(
          existingEntry
            ? "Failed to update time ticket entry"
            : "Failed to create time ticket entry"
        );
      }
    } catch (error) {
      console.error(
        `Error ${
          existingEntry ? "updating" : "creating"
        } time ticket entry:`,
        error.message
      );
      alert(
        `An error occurred while ${
          existingEntry ? "updating" : "creating"
        } time ticket entry`, error.message
      );
    }
  };

  const formFields = [
    // { label: "Time Ticket ID", name: "timeTicketId", type: "text", required: true },
    { label: "Employee ID", name: "employeeId", type: "text", required: true },
    {
      label: "Building Site",
      name: "buildingSite",
      type: "text",
      required: true,
    },
    {
      label: "Device Information",
      name: "deviceInformation",
      type: "text",
      required: false,
    },
    {
      label: "Status",
      name: "status",
      type: "select",
      options: [
        "Active",
        "Needs Review",
        "Billable",
        "Not Billable",
        "Invoiced",
        "Transferred",
        "Internal Tracking",
        "Billing Hold",
      ],
      required: false,
    },
    {
      label: "Problem Class",
      name: "problemClass",
      type: "select",
      options: [
        "ENTRAPMENT",
        "SHUT DOWN",
        "PROBLEM",
        "FOLLOW UP",
        "PRE-SCHEDULED JOB",
        "INSPECTIONS",
        "AM SERVICE",
        "MOBILE SURVEY ITEMS",
        "Planning & Mobilization",
        "STANDBY",
        "MECHANIC INFORMED",
      ],
      required: false,
    },
    {
      label: "Sub Class",
      name: "subClass",
      type: "select",
      options: [
        "DOOR PROBLEM",
        "NOT RESPONDING TO CALLS",
        "ENTRAPMENT",
        "OFF LEVEL",
        "DOORS STUCK OPEN",
        "DOORS STUCK CLOSED",
        "PENDING APPROVAL OF PROPOSAL",
      ],
      required: false,
    },
    { label: "Start Time", name: "startTime", type: "time", required: false },
    { label: "End Time", name: "endTime", type: "time", required: false },
    {
      label: "Ticket Number",
      name: "ticketNumber",
      type: "text",
      required: true,
    },
    {
      label: "Type",
      name: "type",
      type: "select",
      options: [
        "Trouble Call",
        "Maintenance",
        "Follow Up",
        "Proposal/Job Work",
        "Modernization",
        "Time Tracking",
        "Inspection",
        "Other",
        "Survey",
        "Violation",
        "Shut Down",
        "Time & Materials",
        "On Call Mechanic",
        "Standby",
        "Covered Work",
      ],
      required: true,
    },
    {
      label: "Expense",
      name: "expense",
      type: "text",
      required: false,
    },
    {
      label: "Description",
      name: "description",
      type: "text",
      required: false,
    },
    {
      label: "Hours Type",
      name: "hoursType",
      type: "select",
      options: [
        "Standard",
        "Night Shift",
        "Weekend",
        "Holiday",
        "Prevailing Wage",
        "Special 1",
        "Special 2",
        "Mobile Review",
      ],
      required: false,
    },
    {
      label: "Hours",
      name: "hours",
      type: "text",
      required: true,
    },
    {
      label: "Reg",
      name: "reg",
      type: "text",
      required: true,
    },
  ];

  return (
    // <div className="max-w-lg mx-auto mt-10 p-6">
      <div className="max-w-4xl mx-auto mt-10 p-6 gradient-bg rounded-xl shadow-lg">
      <h2 className="text-4xl font-bold mb-6 text-left text-white">
        {existingEntry ? "Edit" : "Create"} Time Ticket Entry
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-2">
          {formFields.map((field) => (
            <div key={field.name}>
              <label className="block text-white">{field.label}:</label>
              {field.type === "select" ? (
                <select
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  required={field.required}
                  className="w-full px-3 py-2 border rounded-md"
                >
                  <option value="">Select an option</option>
                  {field.options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  required={field.required}
                  className="w-full px-3 py-2 border rounded-md"
                />
              )}
            </div>
          ))}
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          {existingEntry ? "Update" : "Add"} Time Ticket Entry
        </button>
      </form>
    </div>
  );
};

export default TimeTicketForm;
